import { APP_MODE, request } from 'ice';
import $i18n from 'panda-i18n';

interface IState {
  btnPermissions: string[];
  menuConfig: [];
  topMenu: MenuItem[];
  authArr: string[];
  auth: string;
  menuArr: MenuItem[];
  home: Object;
}
interface MenuItem {
  label: string;
  value: string;
  path: string;
}

interface MenuConfigItem {
  name: string;
  path?: string;
  icon?: string;
  children?: MenuConfigItem[];
  id: number;
  url: string;
  parentId: number;
  style: string;
  i18nCode: string;
  authArr: string[];
  isDetail?: boolean;
}

console.log(APP_MODE);

export default {
  state: {
    btnPermissions: [] as string[],
    menuConfig: [] as [],
    topMenu: [] as MenuItem[],
    authArr: [] as string[],
    auth: '' as string,
    menuArr: [] as MenuItem[],
    home: { label: $i18n.get({ id: 'Home.four_px', dm: '首页' }), value: 'home', path: '/' },
    usePermission: APP_MODE === 'dev' ? (false as boolean) : (true as boolean),
  },

  effects: (dispatch) => ({
    async fetchUserPermission() {
      const res = await request.get('/auth/getInfo');
      if (res.stringPermissions) {
        dispatch.permission.update({ btnPermissions: res.stringPermissions });
      }
    },
    // 菜单权限处理
    async fetchMenuTreePermission(userid: string) {
      const res = await request({
        method: 'get',
        url: `/openapi/menuTree/${userid}/JrYuZoXOXL0vONhI`,
        headers: {
          auth: true,
        },
      });

      const topMenu: MenuItem[] = [];

      const deali18nFn = (item, code: string, name: string) => {
        if (code?.length) {
          if (item?.style === 'menu') {
            return $i18n.get({ id: `${code}`, dm: name });
          } else {
            return $i18n.get({ id: `${code}.four_px`, dm: name });
          }
        } else {
          return name;
        }
      };

      const dealTopUrl = (e) => {
        if (e?.length) {
          const path = e[0].children?.length ? e[0].children[0]?.url : '/';
          return path;
        }
        return '/';
      };

      const recurrence = (data: MenuConfigItem[]) => {
        const arr = data.filter((e) => e?.url.indexOf(':') === -1 && e?.style !== 'detail_menu');

        return arr?.map((e) => {
          if (e?.parentId === 19318) {
            topMenu.push({
              label: deali18nFn(e, e?.i18nCode, e?.name),
              value: e?.style,
              path: dealTopUrl(e?.children),
            });
            return e?.children && recurrence(e.children);
          }
          return {
            name: deali18nFn(e, e?.i18nCode, e?.name),
            path: e?.url,
            icon: e?.style,
            children: e?.children && recurrence(e.children),
          };
        });
      };

      const menu: MenuConfigItem[] = recurrence(res) || [];
      const menuConfig = {};
      menu?.forEach((e) => {
        if (Array.isArray(e)) {
          menuConfig[e[0]?.path] = e;
        }
      });

      dispatch.permission.updateTopMenuPermission({
        topMenu,
        menuConfig,
      });
    },

    // 获取平铺的菜单数据、为了防止用户通过url访问对应菜单
    async fetchMenuPermission(userid: string) {
      const res = await request({
        method: 'get',
        url: `/openapi/menu/${userid}/JrYuZoXOXL0vONhI`,
        headers: {
          auth: true,
        },
      });

      let menu: MenuConfigItem[] = [];
      if (res?.length) {
        const data = res?.filter((e) => {
          return e?.url && e?.parentId !== 19318;
        });
        const reg = new RegExp(':[^:]+$', 'g');
        menu = data?.map((e) => {
          return {
            name: $i18n.get({ id: `${e?.i18nCode}.four_px`, dm: e?.name }),
            path: e?.url.replace(reg, ''),
            icon: e?.style,
            isDetail: e?.url.indexOf(':') !== -1 || e?.style === 'detail_menu',
          };
        });
      }

      dispatch.permission.updateMenuArrPermission({
        menuArr: menu,
      });
    },

    // 按钮权限处理
    async fetchButtonPermission(userid: string) {
      const res = await request({
        method: 'get',
        url: `/openapi/permission/${userid}/JrYuZoXOXL0vONhI`,
        headers: {
          auth: true,
        },
      });
      dispatch.permission.updateMenuPermission({
        authArr: res,
      });
    },
  }),

  reducers: {
    update(prevState: IState, payload: IState) {
      return { ...prevState, ...payload };
    },

    updateTopMenuPermission(prevState: IState, payload: IState) {
      const datas = { ...prevState, ...payload };
      const topMenu = [...payload?.topMenu];
      topMenu.unshift(prevState?.home);
      datas.topMenu = topMenu;
      return { ...prevState, ...datas };
    },

    updateMenuConfigPermission(prevState: IState, payload: IState) {
      return { ...prevState, ...payload };
    },

    updateMenuArrPermission(prevState: IState, payload: IState) {
      const datas = { ...prevState, ...payload };
      const menuArr = [...payload?.menuArr];
      menuArr.unshift(prevState?.home);
      datas.menuArr = menuArr;
      return { ...prevState, ...datas };
    },

    updateMenuPermission(prevState: IState, payload: IState) {
      return { ...prevState, ...payload };
    },
  },
};
